import ACTION from '@constants/auth'
import { createStandardAction } from 'typesafe-actions'

export const logout = createStandardAction(ACTION.USER_SIGN_OUT)()
